"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCardSection = void 0;
var _CardSection = require("./CardSection");
// TODO: in v9, move styled() from CardSection.jsx to here
var StyledCardSection = _CardSection.CardSection;
exports.StyledCardSection = StyledCardSection;